// extracted by mini-css-extract-plugin
module.exports = {"title":"SquareCardList_title__r_IRO","gridWrap":"SquareCardList_gridWrap__2YCKP"};